@if (isLoading) {
<div id="loading-container">
    <nz-spin nzSimple nzSize="large"></nz-spin>
</div>
} @else {
@if (actionKpi.length > 0) {
<nz-ribbon [nzText]="extraTemplate">
    <nz-card [nzTitle]="titleTemplate">
        <app-graph-action-kpi [actionKpi]="actionKpi"></app-graph-action-kpi>
    </nz-card>
</nz-ribbon>
}
}

<ng-template #titleTemplate>
    <div nz-flex nzWrap="wrap" nzGap="small" nzAlign="center" class="card-action-title">
        <h3>{{ 'dashboard.actionTitle' | translate }}
        </h3>
        <span class="card-action-title-info">{{ 'dashboard.clickableColumns' | translate }}</span>
    </div>

</ng-template>
<ng-template #extraTemplate>
    <h3 class="totalActionText">{{ 'dashboard.total' | translate }} : {{ totalCount }}</h3>
</ng-template>